import React from 'react'
import styled from 'styled-components'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'
interface Props {
    onSave: () => void
    onCancel: () => void
    editMode: boolean
    errorMessage?: string | undefined
    loading: boolean
    variant?: 'primary' | 'secondary'
}

export default function Footer({
    editMode,
    onCancel,
    onSave,
    errorMessage,
    loading,
    variant = 'primary'
}: Props): JSX.Element {
    return (
        <FooterContainer>
            <div className={`reportCardFooter ${variant} ${editMode ? 'editMode' : null}`}>
                {editMode ? (
                    <SubmitOrCancel
                        onSubmit={onSave}
                        onCancel={onCancel}
                        disabled={!!errorMessage || loading}
                        saving={loading}
                    />
                ) : null}
                {editMode ? <label>{errorMessage}</label> : null}
            </div>
        </FooterContainer>
    )
}

const FooterContainer = styled.div`
    .reportCardFooter {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        border-top: 1px solid ${({ theme }) => theme['gray-400']};
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        padding: 0 24px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 3px;
        border-bottom-left-radius: 3px;
        display: none;
        height: 48px;
        background: ${({ theme }) => theme['gray-0']};
    }
    .editMode {
        display: flex;
    }
    .primary {
        background: ${({ theme }) => theme['gray-200']};
    }
    .secondary {
        height: 55px;
    }
`
